import { api, scope } from 'cssapi'
import styled from 'styled-components'
import flexHorizontal from '../../styles/mixins/flexHorizontal'
import uiList from '../../styles/mixins/uiList'

const GridLayout = styled.div`
  ${flexHorizontal};
  ${uiList};
  flex-wrap: wrap;
  justify-content: space-between;

  & > * {
    ${api({
      width: { default: `100%`, [`mediumUp-200`]: `calc(50% - 0.5ru)` },
      marginBottom: scope`1ru`,
    })};
  }
`

export default GridLayout



// WEBPACK FOOTER //
// ./src/components/shared/layouts/GridLayout.jsx